import { type ScopedPermissions } from '@air/api';
import { type ShortIdObjectType } from '@air/provider-short-id';

import { canSeeAssetVersions } from '~/utils/permissions/assetPermissions';

type CanViewAllVersionsOnPublicShareLinkParams = {
  objectType: ShortIdObjectType;
  permissions: { asset: Pick<ScopedPermissions['asset'], 'canViewAllVersions'> } | undefined;
};

/**
 * Whether a public share link may show the version browser (FOUND-567).
 * Clip-typed links are always false, even if the link role still carries
 * `asset.canViewAllVersions`. Other object types keep reading permissions.
 */
export const canViewAllVersionsOnPublicShareLink = ({
  objectType,
  permissions,
}: CanViewAllVersionsOnPublicShareLinkParams) => objectType !== 'clip' && canSeeAssetVersions(permissions);
